/* 2026-10-21 (founder): quiet, intentional motion. Section titles, cards and photos rise 14px and fade in once,
   600ms, one easing everywhere, staggered 70ms inside a group. Nothing loops, nothing bounces, nothing on the
   buy box above the fold. prefers-reduced-motion: off entirely. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = [
    'main .shopify-section:not(:first-child) :is(h2, .pdprt__h2, .pdpwf__h2, .pdppg__h2, .hg__h, .lk__h, .hq__h, .final-cta__title)',
    'main .pdprt__step', 'main .hq__item',
    'main .lk__img', 'main .lk__rows li', 'main .hg__seal', 'main .pst__row',
    'main .pxo'
  ].join(',');
  var els = Array.prototype.slice.call(document.querySelectorAll(SEL)).filter(function (el) {
    var r = el.getBoundingClientRect(); return r.top > window.innerHeight; /* never animate what is already on screen */
  });
  els.forEach(function (el) { el.classList.add('om-in'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min(sib, 5) * 70 + 'ms';
      el.classList.add('om-on'); io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (el) { io.observe(el); });
})();

/* 2026-10-22 (founder): the Welcome Kit opens and closes gracefully instead of snapping. The <details> height is animated
   between its closed and open size (the price list and the photo grid both live behind the toggle), and the new content
   fades up. Reduced-motion users keep the instant toggle. */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('details.pdp-wk > summary');
    if (!sum) return;
    var d = sum.parentElement;
    if (d.dataset.wkAnim === '1') { e.preventDefault(); return; }
    if (!d.animate) return;
    e.preventDefault();
    d.dataset.wkAnim = '1';
    var from = d.offsetHeight, opening = !d.open, to;
    if (opening) { d.open = true; to = d.offsetHeight; }
    else { d.open = false; to = d.offsetHeight; d.open = true; }
    d.style.overflow = 'hidden';
    /* 2026-10-23 (founder): the "See what's inside" / "Hide" label flips the instant you tap, not when the animation ends */
    d.classList.toggle('is-closing', !opening);
    var dur = Math.min(380, Math.max(220, Math.abs(to - from) * 0.6));
    var a = d.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: dur, easing: EASE });
    if (opening) {
      d.querySelectorAll('.wkl__list, .pdp-wk__body').forEach(function (el) {
        el.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: dur, delay: 60, easing: EASE, fill: 'backwards' });
      });
    }
    a.onfinish = a.oncancel = function () {
      if (!opening) d.open = false;
      d.classList.remove('is-closing');
      d.style.overflow = '';
      delete d.dataset.wkAnim;
    };
  });
})();
